import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const TITLES = {
  APPROVE: '결재 승인',
  REJECT: '결재 반려',
};

const ApprovalV2ActionDialog = ({ open, mode, title, onClose, onConfirm }) => {
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (open) {
      setComment('');
    }
  }, [open, mode]);

  const isReject = mode === 'REJECT';

  const handleConfirm = () => {
    if (isReject && !comment.trim()) {
      return;
    }
    onConfirm(comment.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{TITLES[mode] || '결재 처리'}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {title || '결재 문서'}
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={3}
            size="small"
            label={isReject ? '반려 사유 *' : '의견'}
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            error={isReject && !comment.trim()}
            helperText={isReject && !comment.trim() ? '반려 시 사유를 입력하세요.' : ' '}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">취소</Button>
        <Button onClick={handleConfirm} variant="contained" color={isReject ? 'error' : 'success'}>
          {isReject ? '반려' : '승인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalV2ActionDialog;
